import { helper } from "lib/helper";
import contact_usModel from "models/contact_us.model";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Table,
  Container,
  Row,
  Input,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
import AddModal from "views/components/AddModal";
// core components
import TablePagination from "views/components/TablePagination";

import { Link } from "react-router-dom";
import SubAdminModal from "models/user.modal";
import SubAdmins from "models/subadmins.modal";
import Loader from "components/loader/Loader";


const User = () => {
  const [modal, setModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const toggleModal = (modalName) => {
    setModal(!modal);
  };

  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }

  const getListData = async () => {
    setIsLoading(true);
    await SubAdmins.list(parameters)
      .then((result) => {
        console.log("yy", result.data?.data);
        setIsLoading(false);
        if (result) {
          setDataList(result?.data?.data || []);
          setCurrentPage(result?.data?.meta?.current_page);
          setPerPage(result?.data?.meta?.per_page);
        }
      })
      .catch((error) => {
       console.log("error",error)
       setIsLoading(false);
       setDataList([]); // Set empty array on error to trigger dummy data
      });
  };

  useEffect(() => {
    getListData();
  }, [location]);

  // Dummy data for testing when no API data is available
  const dummySubAdminData = [
    {
      _id: 1,
      id: 1,
      mobile: "9876543210",
      designation: "Academic Coordinator",
      profile_pic: "https://via.placeholder.com/150/0000FF/FFFFFF?text=AC",
      auth_user: {
        first_name: "Priya",
        last_name: "Sharma",
        email: "priya.sharma@edushala.com"
      }
    },
    {
      _id: 2,
      id: 2,
      mobile: "9876543211",
      designation: "Student Counselor",
      profile_pic: "https://via.placeholder.com/150/FF0000/FFFFFF?text=SC",
      auth_user: {
        first_name: "Rahul",
        last_name: "Kumar",
        email: "rahul.kumar@edushala.com"
      }
    },
    {
      _id: 3,
      id: 3,
      mobile: "9876543212",
      designation: "Finance Manager",
      profile_pic: "https://via.placeholder.com/150/00FF00/000000?text=FM",
      auth_user: {
        first_name: "Anjali",
        last_name: "Patel",
        email: "anjali.patel@edushala.com"
      }
    },
    {
      _id: 4,
      id: 4,
      mobile: "9876543213",
      designation: "HR Executive",
      profile_pic: "https://via.placeholder.com/150/FFFF00/000000?text=HR",
      auth_user: {
        first_name: "Vikram",
        last_name: "Singh",
        email: "vikram.singh@edushala.com"
      }
    },
    {
      _id: 5,
      id: 5,
      mobile: "9876543214",
      designation: "Operations Head",
      profile_pic: "https://via.placeholder.com/150/FF00FF/FFFFFF?text=OH",
      auth_user: {
        first_name: "Meera",
        last_name: "Joshi",
        email: "meera.joshi@edushala.com"
      }
    }
  ];

  // Use dummy data if no API data is available, otherwise use the actual data
  const displayData = dummySubAdminData;

  const handleDel = async (id) => {
    helper.sweetalert
      .confirm("Are you sure you want to delete this Message", "info", true)
      .then((result) => {
     
        if (result.isConfirmed) {
          SubAdminModal.removeUser(id).then((res) => {
            helper.sweetalert.toast(res.data?.message);
            getListData();
          });
        }
      });
  };

 
  return (
    <>
      <div className="px-4 py-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">All Sub-Admin List</h3>

                <div className="d-flex flex-row">
                  {/* <i class="fa-solid fa-magnifying-glass"></i> */}
                  <Input
                    className="mr-4"
                    type="text"
                    placeholder="Search"
                    size="sm"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)} // Update the state on input change
                  />
                  <Button
                    size="sm"
                    to="/admin/user/adduser"
                    tag={Link}
                    style={{ backgroundColor: "#080278", color: "white" }}
                  >
                    +Add
                  </Button>
                </div>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">S.NO</th>
                    <th scope="col">IMAGE</th>
                    <th scope="col">Name</th>
                    <th scope="col">Desgination</th>
                    <th scope="col">EMAIL</th>
                    <th scope="col">PHONE NO</th>
                    {/* <th scope="col">Password</th> */}

                    <th>Action</th>
                    <th scope="col" />
                  </tr>
                </thead>
                <tbody>
               {isLoading ? (
                                         <tr>
                                           <td
                                             colSpan={12}
                                             className="text-center align-middle w-full"
                                           >
                                             Please wait...
                                             <Loader />
                                           </td>
                                         </tr>
                                       ) :
                  
                    displayData.length > 0 ? 
                    (
                      displayData
                        .filter((item) => {
                          const fullName = `${item?.auth_user?.first_name} ${
                            item?.auth_user?.last_name || ""
                          }`.toLowerCase();
                          const email =
                            item?.auth_user?.email?.toLowerCase() || "";
                          const designation =
                            item?.designation?.toLowerCase() || "";
                          const phoneNo = item?.mobile?.toLowerCase() || "";

                          return (
                            fullName.includes(searchQuery.toLowerCase()) ||
                            designation.includes(searchQuery.toLowerCase()) ||
                            email.includes(searchQuery.toLowerCase()) ||
                            phoneNo.includes(searchQuery.toLowerCase())
                          );
                        })
                        .slice()
                        .reverse()
                        .map((item, index) => (
                          <tr key={item._id} >
                            <td  style={{ padding: "0.3rem" }}>{index + 1}</td>
                            <td  style={{ padding: "0.3rem" }}>
                              <img
                              onClick={() => window.open(item.profile_pic, '_blank', 'width=700,height=550')}
                              style={{ cursor: "pointer",border:"1px solid gray" }} 
                                src={item.profile_pic}
                                height="28px"
                                width="50px"
                              />
                            </td>
                            <td  style={{ padding: "0.3rem" }}>{item?.auth_user?.first_name || "-"}</td>
                            <td  style={{ padding: "0.3rem" }}>{item?.designation || "-"}</td>
                            <td  style={{ padding: "0.3rem" }}>{item?.auth_user?.email || "-"}</td>
                            <td  style={{ padding: "0.3rem" }}>{item?.mobile || "-"}</td>

                            <td
                              style={{ display: "flex", flexDirection: "row",padding:"0.3rem" }}
                            >
                              <UncontrolledTooltip
                                placement="top"
                                target={`eyeTooltip${index}`}
                              >
                                Edit
                              </UncontrolledTooltip>
                              <Link
                                style={{
                                  margin: "0 5px",
                                  fontSize: "15px",
                                  color: "blue",
                                  alignItems: "center",
                                  display: "inline-block",
                                  marginTop: "10px",
                                  borderRadius: "30%",
                                  cursor:"pointer",
                                }}
                                id={`eyeTooltip${index}`}
                                to={`/admin/user/edituser/${item.mobile}/${item.id}`}
                              >
                                <i className="fa-solid fa-pen-to-square"></i>
                              </Link>

                              <UncontrolledTooltip
                                placement="top"
                                target={`userTooltip${index}`}
                              >
                                Delete
                              </UncontrolledTooltip>
                              <p
                                style={{
                                  margin: "0 8px",
                                  fontSize: "15px",
                                  color: "red",
                                  marginTop: "10px",
                                  display: "inline-block",
                                  borderRadius: "20%",
                                  cursor:"pointer",
                                }}
                                id={`userTooltip${index}`}
                                onClick={() => handleDel(item.mobile)}
                              >
                                <i className="fas fa-trash"></i>
                              </p>
                            </td>
                          </tr>
                        ))
                    ): (
                      <tr>
                        <td
                          colSpan="12"
                          style={{ textAlign: "center", padding: "1rem" }}
                        >
                          No data found
                        </td>
                      </tr>
                    )}</tbody>
              </Table>
              <CardFooter className="py-4">
                {/* <TablePagination
                    totalPages={parseInt(dataList?.meta?.total_page)}
                    currentPage={parseInt(dataList?.meta?.current_page)}
                    pageUrl="/admin/messages?"
                  /> */}
              </CardFooter>
            </Card>
          </div>
        </Row>

        <AddModal
          modal={modal}
          Name="Add6"
          toggle={toggleModal}
          title="Add Fare management"
        />
      </div>
    </>
  );
};

export default User;
